// removed by extract-text-webpack-plugin
module.exports = {"NavItem":"NavItem__NavItem__3VNKZ","active":"NavItem__active__DwJX1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavItems/NavItem/NavItem.css
// module id = 73
// module chunks = 0